import * as Yup from 'yup'
import { format } from 'date-fns'
import { getDateFnsFormat } from '../../helpers/time-helper/time-helper'

export const getValidationSchema = (maxDate, userDateFormat = 'YYYY/MM/DD') => {
  const dateFnsFormat = getDateFnsFormat(userDateFormat)

  return Yup.object().shape({
    from: Yup.date()
      .required('Field is required')
      .min(new Date('1900-01-01'), `Min date is ${format(new Date('1900-01-01'), dateFnsFormat)}`)
      .test('Check maxDate', `Max date is ${format(new Date(), dateFnsFormat)}`, (value) => {
        return maxDate ? value <= new Date() : true
      })
      .typeError(`Invalid date format, valid - ${userDateFormat}`)
      .nullable(),
    to: Yup.date()
      .required('Field is required')
      .min(Yup.ref('from'), 'Date current be later than date previous')
      .test('Check maxDate', `Max date is ${format(new Date(), dateFnsFormat)}`, (value) => {
        return maxDate ? value <= new Date() : true
      })
      .typeError(`Invalid date format, valid - ${userDateFormat}`)
      .nullable(),
  })
}
